import React, { useState, useEffect } from 'react';
import { checkAppVersion, storeAppVersion, getVersionDisplay, APP_VERSION } from '../utils/version';

const AppUpdateBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [versionInfo, setVersionInfo] = useState(null);

  useEffect(() => {
    const info = checkAppVersion();
    setVersionInfo(info);
    
    if (info.isUpdate) {
      setShowBanner(true);
    }
  }, []);

  const handleUpdate = () => {
    storeAppVersion();
    setShowBanner(false);
    // Prompt user to refresh
    alert('✅ App updated! Please refresh the page to see the latest version.');
    window.location.reload();
  };

  const handleDismiss = () => {
    // Store that user dismissed this version
    localStorage.setItem('app_update_dismissed', APP_VERSION);
    setShowBanner(false);
  };

  // Don't show if already dismissed
  const dismissed = localStorage.getItem('app_update_dismissed') === APP_VERSION;
  if (!showBanner || dismissed || !versionInfo?.isUpdate) return null;

  return (
    <div className="fixed top-16 left-4 right-4 z-50 md:left-1/2 md:right-auto md:-translate-x-1/2 bg-yellow-50 border border-yellow-300 rounded-lg shadow-xl p-4 max-w-md mx-auto">
      <div className="flex items-start gap-3">
        <div className="flex-1">
          <p className="font-semibold text-sm text-yellow-800">🔄 App Update Available</p>
          <p className="text-xs text-yellow-700 mt-1">
            Version {getVersionDisplay()} is now available. 
            You're on v{versionInfo.stored}.
          </p>
          <p className="text-xs text-yellow-600 mt-1">
            Tap Update to refresh the app and see new features.
          </p>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <button
            onClick={handleUpdate}
            className="bg-yellow-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-yellow-700 transition"
          >
            Update
          </button>
          <button
            onClick={handleDismiss}
            className="text-yellow-500 hover:text-yellow-700 text-sm px-2"
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppUpdateBanner;
